module.exports = __webpack_public_path__ + "img/STCActive.a8371bbd.svg";